(function($){

    var c = {
      init: function(){
        c.focusTab();
      },
      focusTab:function(){
        let searchParams = new URLSearchParams(window.location.search)
        let focus = searchParams.get('focus')
        if( focus === null ){ return false; }
        if(focus.length){
          var ele = document.querySelector('#'+focus)
          new bootstrap.Tab(ele).show();
        }
      }
    };

    c.init();

  })(jQuery);
